var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{
    'common-list-status': true,
    'loading-end': _vm.loadingEnd
  }},[_c('icon',{staticClass:"icon",style:({ color: _vm.customColor }),attrs:{"name":"logo"}}),_c('div',{staticClass:"text",style:({ color: _vm.customColor })},[_vm._v(_vm._s(_vm.showText))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }